import {createRoot} from 'react-dom/client'
import App from './app.tsx'
import {events, EventType, iws, type NetResult, type NetState, onair, wpi} from "./modules/config.ts";
import type WpiBase from "./modules/interfaces/wpi.base.ts";
import {IWSService} from "./modules/iws.service.ts";
import type {EventBus} from "./modules/event.bus.ts";
import type {Onair} from "./modules/onair.ts";
import {store} from "./stores";
import {Provider} from "react-redux";

declare global {
  // noinspection JSUnusedGlobalSymbols
  interface Navigator {
    vendor: any;
  }

  // noinspection JSUnusedGlobalSymbols
  interface Window {
    webkit: any;
    MSStream?: any;
    // @ts-ignore
    external?: WpiBase;
    opera?: any;
    webkitAudioContext?: typeof AudioContext;
    audioContext?: AudioContext | null
    wpi?: WpiBase;
    wps?: IWSService;
    wpe?: EventBus;
    wpo?: Onair;
    network_status?: (res: NetResult) => void;
    showResumeUI?: () => void;
  }
}

// ios 주입된 싱글톤 오디오텍스트
export const audioContext = new (window.AudioContext)();
window.audioContext = audioContext;

// interface
window.wpi = wpi;
// service
window.wps = iws;
// event
window.wpe = events;
// onair
window.wpo = onair;

// iOS 네이티브(AudioSessionManager)가 오디오 인터럽트 종료 후 호출하는 복구 훅
// iOS 15에서는 제스처 없는 AudioContext.resume()이 무시될 수 있으므로
// needResume(컨텍스트 resume + 플레이어 재개)을 통해 복구를 시도한다.
window.showResumeUI = () => {
  iws.needResume().catch(() => {});
};

let lastState: NetState | null = null;
window.network_status = (res: NetResult) => {
  if (lastState !== res.state) {
    lastState = res.state;
  }
  console.log('[NET]', res);

  // 상태별 처리
  switch (res.state) {
    case 'NO_NETWORK':
      events.emit(EventType.NETWORK_CHANGE, 0, '네트워크가 없습니다.');
      break;

    case 'NO_INTERNET':
      events.emit(EventType.NETWORK_CHANGE, 0, '인터넷에 연결할 수 없습니다. Wi-Fi 로그인/네트워크를 확인하세요.');
      break;

    case 'SLOW': {
      const rtt = res.rttMs ?? -1;
      events.emit(EventType.NETWORK_CHANGE, 0, `네트워크가 느립니다${rtt > 0 ? ` (RTT ${rtt}ms)` : ''}. 저음질/절약모드로 전환합니다.`);
      break;
    }

    case 'OK':
      events.emit(EventType.NETWORK_CHANGE, 1);
      break;
  }
};

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <App />
  </Provider>
);
